// extracted by mini-css-extract-plugin
export default {"container":"BusinessIntegration_container__e5nn9","description":"BusinessIntegration_description__a4Okq","title":"BusinessIntegration_title__r9aQh"};